const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Financial = 'Financial'
const Supervisor = 'Supervisor'
const Clerk = 'Clerk'
const Seller = 'Seller'
const Assistant = 'Assistant'
const SalesExecutive = 'SalesExecutive'
const Logistics = 'Logistics'
const CreditAnalyst = 'CreditAnalyst'

// TODAS AS ROLES EM REGISTRATIONS PRECISAM ESTAR DISPONIVEIS NO DRAWER !!!
const registrations = [
  {
    icon: 'mdi-clipboard-account-outline',
    text: "Clientes",
    subtitle: "Cadastre ou liste os clientes",
    name: 'CrudClients',
    path_name: 'ClientList',
    to_register_path: 'CreateClient',
    to: '/clients',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-whatsapp',
    text: "Mensagens WhatsApp",
    subtitle: "Fila de envio e status",
    name: 'WhatsappMessages',
    path_name: 'WhatsappMessages',
    to_register_path: '',
    to: '/whatsapp_messages',
    roles: [Director, SalesExecutive, Analyst, CreditAnalyst],
  },
  {
    icon: 'mdi-account-box-multiple',
    text: "Carteira de Clientes",
    subtitle: "Cadastre ou liste os Carteira de Clientes",
    name: 'ClientPortfolios',
    path_name: 'ClientPortfolios',
    to_register_path: 'CreateClientPortfolios',
    to: '/client_portifolios',
    roles: [Director, SalesExecutive, Manager, Logistics],
  },
  {
    icon: 'mdi-domain',
    text: "Empresas",
    subtitle: "Cadastre ou liste as empresas",
    name: 'Companies',
    path_name: 'Companies',
    to_register_path: 'CreateCompanies',
    to: '/companies',
    roles: [Director],
  }, 
  {
    icon: 'mdi-currency-usd',
    text: "Formas de Pagamento",
    subtitle: "Cadastre ou liste as formas de pagamento",
    name: 'PaymentOptions',
    path_name: 'PaymentOptions',
    to_register_path: '',
    to: '/payment_options',
    roles: [Director],
  }, 
  
  {
    icon: 'mdi-clipboard-account',
    text: "Funcionários",
    subtitle: "Cadastre ou liste os funcionários",
    name: 'CrudEmployee',
    path_name: 'EmployeeList',
    to_register_path: 'CreateEmployee',
    to: '/employees',
    roles: [Director],
  },

  {
    icon: 'mdi-store',
    text: "Galpões",
    subtitle: "Cadastre ou liste os galpões",
    name: 'CrudRetails',
    path_name: 'ModalityList',
    to_register_path: 'ModalityRegister',
    params: {solution: 'retail'},
    to: '/modalities',
    roles: [Director],
  },
  {
    icon: 'mdi-store',
    text: "Grandes Cargas",
    subtitle: "Cadastre ou liste novas regiões",
    name: 'CrudWholesale',
    path_name: 'ModalityListWholesale',
    to_register_path: 'ModalityRegisterWholesale',
    params: {solution: 'wholesale'},
    to: '/modalities',
    roles: [Director],
  },
  {
    icon: 'mdi-factory',
    text: "Fornecedores",
    subtitle: "Cadastre ou liste os fornecedores e produtos",
    name: 'CrudBrands',
    path_name: 'Suppliers',
    to_register_path: 'CreateSuppliers',
    to: '/brands_list',
    roles: [Director, SalesExecutive, Manager, Logistics],
  },
  {
    icon: 'mdi-account-group',
    text: "Grupos Econômicos",
    subtitle: "Cadastre ou liste os grupos econômicos",
    name: 'EconomicGroups',
    path_name: 'EconomicGroups',
    to_register_path: 'CreateEconomicGroup',
    to: '/economic_groups',
    roles: [Director, SalesExecutive, Manager, CreditAnalyst],
  },
  {
    icon: 'mdi-pin',
    text: "Local de Retira",
    subtitle: "Cadastre ou liste os locais de retira",
    name: 'PickupLocations',
    path_name: 'PickupLocations',
    to_register_path: 'CreatePickupLocation',
    to: '/pickup_location',
    roles: [Director, SalesExecutive, Manager, Logistics],
  },
  {
    icon: 'mdi-truck-fast-outline',
    text: "Tabela de Fretes",
    subtitle: "Liste e gerencie fretes por local de retira",
    name: 'ShippingRates',
    path_name: 'ShippingRates',
    to_register_path: '',
    to: '/shipping_rates',
    roles: [Director, SalesExecutive, Manager, Logistics],
  },
  {
    icon: 'mdi-shipping-pallet',
    text: "Paletes",
    subtitle: "Cadastre ou liste os paletes",
    name: 'Pallets',
    path_name: 'Pallets',
    to_register_path: '',
    to: '/pallets',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-map',
    text: "Regiões",
    subtitle: "Cadastre ou liste as regiões geográficas",
    name: 'Regions',
    path_name: 'Regions',
    to_register_path: '',
    to: '/regions',
    roles: [Director, SalesExecutive, Manager, Logistics],
  },
  {
    icon: 'mdi-file-export',
    text: "Exportações",
    subtitle: "Lista de exportações",
    name: 'DataExport',
    path_name: 'DataExport',
    to_register_path: '',
    to: '/data_export',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-card-account-details',
    text: "Motoristas 3º e Transportadoras",
    subtitle: "Cadastre ou liste os motoristas terceiros e transportadoras.",
    name: 'DriversList',
    path_name: 'DriversList',
    to_register_path: 'DriverRegister',
    to: '/drivers',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-truck',
    text: "Veículos",
    subtitle: "Cadastre ou liste os veículos",
    name: 'IndexTrucks',
    path_name: 'IndexTrucks',
    to_register_path: 'CreateTruck',
    to: '/trucks',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-office-building-plus-outline',
    text: "Obras",
    subtitle: "Cadastre ou liste as obras",
    name: 'Buildings',
    path_name: 'Buildings',
    to_register_path: 'CreateBuilding',
    to: '/buildings',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
]
const financials = [
  {
    icon: 'mdi-file-document',
    text: "Relatório Diário",
    name: 'MainDaily',
    path_name: 'MainDaily',
    to: '/main_daily',
    roles: [Director, SalesExecutive],
  },
  {
    icon: 'mdi-barcode',
    text: "Boletos",
    name: 'Bills',
    path_name: 'Bills',
    to: '/financial/bills',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-text-box-plus',
    text: "Bônus do cliente",
    name: 'AvailableBonus',
    path_name: 'AvailableBonus',
    to: '/client_bonus/available',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-note',
    text: "Cheques Relacionados",
    name: 'Checks',
    path_name: 'OpenChecks',
    to: '/financial/checks/open',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-note-alert',
    text: "Cheques Retornados",
    name: 'ReturnedChecks',
    path_name: 'ReturnedChecks',
    to: '/financial/returned_checks/to_confirm',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-email-open',
    text: "Depósitos",
    name: 'Deposits',
    path_name: 'OpenDeposits',
    to: '/financial/deposits/open',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-email',
    text: "Envelopes",
    name: 'Envelopes',
    path_name: 'OpenEnvelopes',
    to: '/financial/envelopes/open',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, CreditAnalyst],
  },
  {
    icon: 'mdi-truck-cargo-container',
    text: "Fretes a Pagar",
    name: 'IndexPayShippings',
    path_name: 'IndexPayShippings',
    to: '/pay_shippings',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics],
  },
  {
    icon: 'mdi-order-bool-descending',
    text: "Pedidos a Receber",
    name: 'ToReceive',
    path_name: 'ToReceiveOrders',
    to: '/financial/orders/to_receive',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-swap-horizontal',
    text: "Permutas",
    name: 'Exchanges',
    path_name: 'OpenExchanges',
    to: '/financial/exchanges/open',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-qrcode',
    text: "Pix",
    name: 'AllPix',
    path_name: 'AllPix',
    to: '/pix',
    roles: [Director, SalesExecutive],
  },
  {
    icon: 'mdi-export',
    text: "Exportações Renovar",
    name: 'RenoveExports',
    path_name: 'RenoveExports',
    to: '/renove_exports',
    roles: [Director],
  },
  {
    icon: 'mdi-view-dashboard',
    text: "Francesinha",
    name: 'IncomesExtract',
    path_name: 'IncomesExtract',
    to: '/incomes_extract',
    roles: [Director],
  },
  {
    icon: 'mdi-monitor-dashboard',
    text: "Consolidação",
    name: 'PeriodicConsolidations',
    path_name: 'PeriodicConsolidations',
    to: '/periodic_consolidations',
    roles: [Director],
  },
  {
    icon: 'mdi-percent-outline',
    text: "Configuração de Comissões",
    name: 'SellerComissionConfigs',
    path_name: 'SellerComissionConfigs',
    to: '/seller_comission_configs',
    roles: [Director, SalesExecutive],
  },
  {
    icon: 'mdi-finance',
    text: "Dados financeiros consolidados",
    name: 'FinancialConsolidatedReports',
    path_name: 'FinancialConsolidatedReports',
    to: '/financial/consolidated_data',
    roles: [Director, SalesExecutive],
  },

]

const drawer = [
  {
    icon: 'mdi-home',
    text: "Página Inicial",
    name: 'Home',
    path_name: '',
    to:"/",
    roles: [Director, Manager, Analyst, Supervisor, SalesExecutive],

  },
  {
    icon: 'mdi-file-export',
    text: "Exportações",
    name: 'DataExport',
    path_name: '',
    to: '/data_export',
    roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
  },
  {
    icon: 'mdi-clipboard-text',
    text: "CADASTROS",
    tag_role_control: 'crud_roles',
    //roles: [Director, Manager, Analyst, Supervisor, SalesExecutive, Financial, Clerk,],
    roles: allChildrenUsedRoles(registrations),

    children: [
      ...registrations,
    ]
  },
  {
    icon: 'mdi-currency-usd',
    text: "FINANCEIRO",
    name: 'Financial',
    path_name: '',
    //roles: [Director, Manager, SalesExecutive, Financial, Seller],
    roles: allChildrenUsedRoles(financials),
    children: [
      ...financials,
    ]
  },
  {
    icon: 'mdi-cog',
    text: "Configurações",
    name: 'SystemFlags',
    path_name: '',
    to: '/settings',
    roles: [Director],
  },
]

function allChildrenUsedRoles(array) {
  let all_roles = []
  array.forEach( el => {
    all_roles.push(el.roles)
  })
  let used_roles = new Set(...all_roles)
  return Array.from(used_roles)
}

const bottom = [
  {
    icon: 'mdi-check',
    text: "Home",
    to: "/",
    icon: "$vuetify.icons.home",
    active: true
  },
  {
    icon: 'mdi-check',
    text: "Minha Conta",
    to: "/account",
    icon: "$vuetify.icons.user",
    active: true
  },
  {
    icon: 'mdi-check',
    text: "Atividade",
    to: "/logout",
    icon: "$vuetify.icons.logout",
    active: true
  }
];

export { drawer, bottom };
